import * as React from "react";
import styled from "styled-components";
import StringUtils from "util/StringUtils";
import { Alert } from "components/bootstrap";
const Container = styled(Alert)`
  margin-top: 20px;
  max-height: 240px;
  overflow: auto;
`;
const List = styled.ul`
  list-style: initial;
  padding-left: 20px;

  ul {
    list-style: circle;
  }
`;
const _cap = StringUtils.capitalizeFirstLetter;
const DependenciesWarning = ({ missingDependencies, availableGrantees }) => /* @__PURE__ */ React.createElement(Container, { bsStyle: "danger", title: "There are missing dependencies for the current set of collaborators" }, /* @__PURE__ */ React.createElement(List, null, missingDependencies.entrySeq().map(([granteeGRN, dependencyList]) => {
  const grantee = availableGrantees.find((selectedGrantee) => selectedGrantee.id === granteeGRN);
  return grantee && /* @__PURE__ */ React.createElement("li", { key: grantee.id }, _cap(grantee.type), " ", /* @__PURE__ */ React.createElement("i", null, grantee.title), " needs access to", dependencyList.map((dependency) => /* @__PURE__ */ React.createElement(List, { key: dependency.id }, /* @__PURE__ */ React.createElement("li", null, _cap(dependency.type), ": ", /* @__PURE__ */ React.createElement("i", null, dependency.title), /* @__PURE__ */ React.createElement("br", null), "Owners:", " ", dependency.owners.map((owner, key) => /* @__PURE__ */ React.createElement("span", { key: owner.id }, _cap(owner.type), " ", /* @__PURE__ */ React.createElement("i", null, owner.title), key !== dependency.owners.size - 1 && ", "))))));
}).toArray()));
export default DependenciesWarning;
